var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "feature-list-section",
    style: _vm.style
  }, [_c('Container', [_c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_c('h2', {
    staticClass: "section-header feature-list-section-heading text-left lg:text-center xl:text-center"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.heading) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "h-full grid grid-cols-4 gap-x-4 gap-y-4 md:grid-cols-1 md:gap-y-8 sm:grid-cols-1 sm:gap-y-8"
  }, _vm._l(_vm.list, function (listItem) {
    return _c('div', {
      key: listItem._key,
      staticClass: "feature-list"
    }, [_c('div', [_c('img', {
      attrs: {
        "src": _vm.imageUrl(listItem.image.image),
        "alt": listItem.image.alt
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "mb-4 feature-list-heading"
    }, [_vm._v(_vm._s(listItem.heading))]), _vm._v(" "), _c('div', {
      staticClass: "divider"
    }), _vm._v(" "), _c('h4', {
      staticClass: "feature-list-subheading"
    }, [_vm._v(_vm._s(listItem.subheading))]), _vm._v(" "), _c('SanityBlockContent', {
      staticClass: "feature-list-text",
      attrs: {
        "blocks": listItem.text
      }
    })], 1);
  }), 0)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };